var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReboot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1257.21 373.184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1241.662-368.29l.808-.338a7.074,7.074,0,0,0-2.585-3.038l-.491.7A6.178,6.178,0,0,1-1241.662-368.29Z",
    transform: "translate(-2.951 -0.337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1248.805-372.3a6.1,6.1,0,0,1,1.633.225l.239-.844a6.906,6.906,0,0,0-3.983.07l.253.838a6.128,6.128,0,0,1,1.855-.29Z",
    transform: "translate(-1.399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1254.177-361.14a6.036,6.036,0,0,0,3.166,1.4l-.148.9a6.991,6.991,0,0,1-5.981-5.951,7.742,7.742,0,0,1-.07-1.036,6.979,6.979,0,0,1,1.672-4.542l.047-.047.249-.273-1.353-.086.039-.873,2.917.164-.155,2.905-.879-.054.086-1.4-.28.249A6.141,6.141,0,0,0-1254.177-361.14Z",
    transform: "translate(0 -0.341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1242.86-358.046a6.941,6.941,0,0,1-3.889,2.056l-.1-.9a6.089,6.089,0,0,0,3.352-1.784Z",
    transform: "translate(-2.302 -3.225)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1240.422-361.212l-.778-.421a6.136,6.136,0,0,0,.677-2.8,7.347,7.347,0,0,0-.062-.826l.863-.117A6.945,6.945,0,0,1-1240.422-361.212Z",
    transform: "translate(-3.558 -1.734)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.832,
    height: 3.575,
    transform: "translate(-1250.56 -370.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1245.659-364.62a3.422,3.422,0,0,1-3.415,3.42,3.415,3.415,0,0,1-3.407-3.42,3.4,3.4,0,0,1,1.937-3.03l.28-.133v.943l-.1.054a2.511,2.511,0,0,0-1.283,2.173,2.565,2.565,0,0,0,2.535,2.524,2.565,2.565,0,0,0,1.828-.724,2.527,2.527,0,0,0,.785-1.808,2.533,2.533,0,0,0-1.283-2.165l-.1-.054v-.943l.28.133A3.4,3.4,0,0,1-1245.659-364.62Z",
    transform: "translate(-1.051 -1.269)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReboot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reboot.a3a199c228623924e23bc92e6072cbc3.svg";